/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import TemplateInfoWithFolder from './TemplateInfoWithFolder';

/**
 * The NewStaticsResponseTemplates model module.
 * @module model/NewStaticsResponseTemplates
 * @version 1.0.0
 */
class NewStaticsResponseTemplates {
    /**
     * Constructs a new <code>NewStaticsResponseTemplates</code>.
     * Mapa de plantillas disponibles. Vacío si el contrato no es de Madrid o no está mapeado. 
     * @alias module:model/NewStaticsResponseTemplates
     */
    constructor() { 
        
        NewStaticsResponseTemplates.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NewStaticsResponseTemplates</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NewStaticsResponseTemplates} obj Optional instance to populate.
     * @return {module:model/NewStaticsResponseTemplates} The populated <code>NewStaticsResponseTemplates</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NewStaticsResponseTemplates();

            if (data.hasOwnProperty('annex_8')) {
                obj['annex_8'] = TemplateInfoWithFolder.constructFromObject(data['annex_8']);
            }
            if (data.hasOwnProperty('annex_9')) {
                obj['annex_9'] = TemplateInfoWithFolder.constructFromObject(data['annex_9']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/TemplateInfoWithFolder} annex_8
 */
NewStaticsResponseTemplates.prototype['annex_8'] = undefined;

/**
 * @member {module:model/TemplateInfoWithFolder} annex_9
 */
NewStaticsResponseTemplates.prototype['annex_9'] = undefined;






export default NewStaticsResponseTemplates;

